import React from 'react';
import type { CashSummary } from '../../types/cash';

function eur(n: number | null | undefined) {
  const v = Number(n ?? 0);
  return v.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
}

export function CashKpiCards({ summary }: { summary: CashSummary }) {
  return (
    <div className="row g-3">
      <div className="col-12 col-md-6 col-xl-3">
        <div className="card h-100">
          <div className="card-body">
            <div className="text-muted small">Incasso</div>
            <div className="h4 mb-0">{eur(summary.salesTotal)}</div>
          </div>
        </div>
      </div>

      <div className="col-12 col-md-6 col-xl-3">
        <div className="card h-100">
          <div className="card-body">
            <div className="text-muted small">Contanti</div>
            <div className="h4 mb-0">{eur(summary.cashTaken)}</div>
          </div>
        </div>
      </div>

      <div className="col-12 col-md-6 col-xl-3">
        <div className="card h-100">
          <div className="card-body">
            <div className="text-muted small">Bancomat</div>
            <div className="h4 mb-0">{eur(summary.cardTaken)}</div>
          </div>
        </div>
      </div>

      <div className="col-12 col-md-6 col-xl-3">
        <div className="card h-100">
          <div className="card-body">
            <div className="text-muted small">Movimenti netti</div>
            <div className="h4 mb-0">{eur(summary.drawerMovements.net)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}